const Close = ({
  size = 24,
  width,
  height,
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? size}
    height={height ?? size}
    viewBox="0 0 512 512"
    fill={color}
    {...props}
  >
    <path d="M108.75 428.25c-6.4 0-12.8-2.44-17.68-7.32-9.76-9.76-9.76-25.59 0-35.36l294.51-294.5c9.76-9.76 25.59-9.76 35.36 0 9.76 9.76 9.76 25.59 0 35.36l-294.52 294.5a24.902 24.902 0 0 1-17.67 7.32z" />
    <path d="M403.25 428.25c-6.4 0-12.8-2.44-17.68-7.32L91.07 126.42c-9.76-9.76-9.76-25.59 0-35.36 9.76-9.76 25.59-9.76 35.36 0l294.51 294.51c9.76 9.76 9.76 25.59 0 35.36a24.965 24.965 0 0 1-17.69 7.32z" />
  </svg>
);

export default Close;
